import { render, staticRenderFns } from "./branch-stock.vue?vue&type=template&id=6d78e02a"
import script from "./branch-stock.vue?vue&type=script&lang=js"
export * from "./branch-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports